import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getActionByHtml } from "@/utilities/datatable/columnFunctions";

import useTitle from "../../../../utilities/hooks/useTitle";
import ContractPublishToAppLocumIcon from "../../../Icons/ContractPublishToAppLocumIcon";
import ReadMoreWrapper from "../../ReadMoreWrapper";
import CandidateDetailSkeleton from "../candidatedetail/Listing/CandidateRightFullProfileInfo/CandidateDetailSkeleton";
import LiveTimerText from "../contracts/Unfilled/LiveTimerText";
const ContractInfo = () => {
  const dispatch = useDispatch();
  const [publishToAppLocumLoading, setPublishToAppLocumLoading] =
    useState(false);

  const { contractDetails, isContractInfoLoading } = useSelector(
    (state) => state.clientContractDetail,
  );
  const { clientUserAllPermissions, isPremiumAccount } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);

  useTitle(contractDetails?.contract_ref_no);

  const contract_ids = Array.isArray(contractDetails?.contract_id)
    ? contractDetails.contract_id.join(",")
    : contractDetails?.contract_id || "";

  const renderSkeleton = () => (
    <CandidateDetailSkeleton.CandidateRightProfile
      SkeletonNumber={1}
      height={16}
    />
  );

  const publishContract = (e) => {
    if (!isPremiumAccount) {
      e.preventDefault();
      dispatch(toggleOurServiceModal(true));
      return;
    }

    // dispatch(
    //   updateUnfilledPublishContractForAppLocum({
    //     contract_ids,
    //     callback: () => dispatch(fetchContractDetailsData({ contract_id: contract_ids })),
    //     loading: publishToAppLocumLoading,
    //     setLoading: setPublishToAppLocumLoading,
    //     isSelectedAll: false,
    //     ignoreIds: "",
    //   })
    // );
  };

  return (
    <div className="ContractInfo_Wrapper">
      <div className="min-h-[122px] rounded-lg border border-primary bg-lightblue p-3">
        <div className="flex flex-wrap justify-between gap-6">
          {[
            "contract_ref_no",
            "contract_role",
            "created_date",
            "job_title",
          ].map((key) => (
            <div key={key} className="flex flex-col gap-2">
              <span className="text-[14px] font-semibold text-txtColor">
                {key === "contract_role"
                  ? "Role"
                  : key
                      .replace("_", " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>
              <span
                className={`text-[14px] font-medium text-black ${key === "contract_ref_no" && !isContractInfoLoading ? "items-center rounded-md border border-primary p-1 text-center text-primary" : ""}`}
              >
                {isContractInfoLoading
                  ? renderSkeleton()
                  : contractDetails?.[key]}
              </span>
            </div>
          ))}

          {contractDetails?.contract_status === "Booked" && (
            <div className="flex flex-col gap-2">
              <span className="text-[14px] font-semibold text-txtColor">
                Booked By
              </span>
              <div className="text-[14px] font-medium text-black">
                {getActionByHtml(
                  contractDetails?.booked_by_name,
                  contractDetails?.booked_at,
                  contractDetails?.booked_from,
                  "",
                )}
              </div>
            </div>
          )}

          <div className="flex max-w-[340px] grow flex-col gap-2">
            <span className="text-[14px] font-semibold text-txtColor">
              Job Description
            </span>
            <div className="max-h-[250px] min-h-[30px] overflow-y-scroll text-[14px] font-medium text-black scrollbar-hide">
              {isContractInfoLoading ? (
                renderSkeleton()
              ) : (
                <ReadMoreWrapper
                  cls="text-txtDark pr-2"
                  text={contractDetails?.job_description}
                  readMoreText={
                    <span className="text-primary"> Read More</span>
                  }
                  readLessText={
                    <span className="text-primary"> Read Less</span>
                  }
                  max={200}
                />
              )}
            </div>
          </div>

          {isPremiumAccount ? (
            user?.is_bank_client ? (
              <div className="flex flex-col gap-2">
                <div>
                  <span className="text-[14px] font-semibold leading-[normal] text-txtColor">
                    Contract status
                  </span>
                  <div className="grid gap-4">
                    {isContractInfoLoading ? (
                      renderSkeleton()
                    ) : contractDetails?.is_for_appLocum_candidates ? (
                      contractDetails?.is_bank_contract ? (
                        <LiveTimerText
                          actionedAt={contractDetails.contract_created_at}
                          publisheddAt={
                            contractDetails.bank_contract_publish_date
                          }
                        />
                      ) : (
                        <p className="text-[14px] font-medium leading-[normal] text-black">
                          Published to AppLocum Candidates
                        </p>
                      )
                    ) : (
                      <p className="text-[14px] font-medium leading-[normal] text-black">
                        Bank contract
                      </p>
                    )}

                    {contractDetails?.contract_tag == "bank" &&
                    contractDetails?.contract_status !== "Worked" &&
                    contractDetails?.contract_status !== "Booked" ? (
                      // <Tooltip title={TOOLTIPTEXT.publishForApplocum}>
                      <div
                        className={`transition-linear group flex cursor-pointer place-items-center gap-1 rounded-md border border-primary px-2 py-2 text-[14px] font-medium text-primary hover:bg-primary hover:text-white`}
                        onClick={(e) => {
                          publishContract(e);
                        }}
                      >
                        <ContractPublishToAppLocumIcon cls="w-[26px] h-[26px] text-primary group-hover:text-white" />
                        Publish to AppLocum now
                      </div>
                    ) : // </Tooltip>
                    null}
                  </div>
                </div>
              </div>
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ContractInfo;
